import { render } from "./FollowRecommendations.vue?vue&type=template&id=6e74fdb3&scoped=true"
import script from "./FollowRecommendations.vue?vue&type=script&lang=js"
export * from "./FollowRecommendations.vue?vue&type=script&lang=js"

import "./FollowRecommendations.vue?vue&type=style&index=0&id=6e74fdb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e74fdb3"]])

export default __exports__